import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {CreelMap} from '@domain/textile-data/creel/creel-map';
import {OverviewListColoredYarnSetWithStartDent} from '@domain/textile-data/creel/overview-list-colored-yarn-set-with-start-dent';
import {MaterialTypeOverviewList, OverviewListCreelPosition} from '@domain/textile-data/creel/overview-list-creel-position';
import {AssertionUtils, DateTimeFormat, DateTimePipe} from '@vdw/angular-component-library';
import {PathItemInfoTooltipContext} from './path-item-info-tooltip-context.enum';

@Component({
  selector: 'app-path-item-info-tooltip',
  templateUrl: './path-item-info-tooltip.component.html',
  styleUrls: ['./path-item-info-tooltip.component.scss']
})
export class PathItemInfoTooltipComponent {
  public readonly context: PathItemInfoTooltipContext;

  public readonly image: any;
  public readonly width: number;
  public readonly length: number;
  public readonly widthInDents: number;
  public readonly heightInPicks: number;
  public readonly number: number;
  public readonly quantity: number;
  public readonly numberOfPieces: string;
  public readonly quality: string;
  public readonly drawingName: string;
  public readonly finishingName: string;
  public readonly cutbarAfter: number;
  public readonly cutbarBefore: number;
  public readonly cutbarAfterInPicks: number;
  public readonly cutbarBeforeInPicks: number;

  public readonly isSisal: boolean;
  public readonly coloredYarnSet: OverviewListColoredYarnSetWithStartDent;
  public readonly creelMapping: CreelMap;
  public readonly mainColorPosition: number;
  public readonly borderColorPosition: number;
  public readonly shape: string;
  public readonly finishingVersion: number;

  public readonly sales: string;
  public readonly dueDate: string;
  public readonly orderline: string;
  public readonly customer: string;

  public readonly pathItemInfoTooltipContext = PathItemInfoTooltipContext;

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    dateTimePipe: DateTimePipe
  ) {
    this.context = data.context;

    this.image = data.image;
    this.number = data.number;
    this.drawingName = data.drawingName;

    this.width = Math.round(data.width * 10) / 10;
    this.length = Math.round(data.length * 10) / 10;
    this.widthInDents = data.widthInDents;
    this.heightInPicks = data.heightInPicks;
    this.quantity = data.quantity;
    this.numberOfPieces = data.numberOfPieces;
    this.quality = data.quality;

    this.finishingName = data.finishingName;
    this.cutbarAfter = data.cutbarAfter;
    this.cutbarBefore = data.cutbarBefore;
    this.cutbarAfterInPicks = data.cutbarAfterInPicks;
    this.cutbarBeforeInPicks = data.cutbarBeforeInPicks;

    this.isSisal = data.isSisal;
    this.coloredYarnSet = data.coloredYarnSet;
    this.creelMapping = data.creelMapping;
    this.mainColorPosition = data.mainColorPosition;
    this.borderColorPosition = data.borderColorPosition;
    this.shape = data.shape;
    this.finishingVersion = data?.finishingVersion;

    this.sales = data.sales;
    this.orderline = data.orderline;
    this.dueDate = dateTimePipe.transform(data.dueDate, DateTimeFormat.DATE_SHORT);
    this.customer = data.customer;
  }

  public hasCutBarAfter(): boolean {
    return !AssertionUtils.isNullOrUndefined(this.cutbarAfter);
  }

  public hasCutBarBefore(): boolean {
    return !AssertionUtils.isNullOrUndefined(this.cutbarBefore);
  }

  public getColorByPosition(position: number): MaterialTypeOverviewList[] {
    return this.coloredYarnSet.coloredYarnSet.overviewListColorSet.creelPositions.find((creelPosition: OverviewListCreelPosition) => creelPosition.position === position)?.items;
  }

  public canShowInfoEntry(context: PathItemInfoTooltipContext): boolean {
    return this.context === context;
  }

  public getPopupHeight(): string {
    return this.context === PathItemInfoTooltipContext.PATH_DESIGN ? '400px' : '300px';
  }
}
